/**
 * Enterprise status colors for services (listing, messages, filters).
 * Distinct per status; customer-approval leans on active theme accent.
 */

const FALLBACK_THEME = "#1E72B8";

/** Base solid hex per status (theme-independent) */
export const SERVICE_STATUS_BASE = {
  GarageInitiate: "#64748B", // slate — intake
  GarageToOp: "#F59E0B", // amber — sent to OP
  WaitingForOpApproval: "#F59E0B", // amber — awaiting OP (same as GarageToOp)
  OpToCustomer: "#6366F1", // indigo — OP → customer (distinct from GarageToOp)
  GarageToCustomer: "#6366F1", // indigo — same waiting-for-customer group
  WaitingForCustomerApproval: "#6366F1", // indigo — awaiting customer
  required: "#0284C7", // sky — due / approved path
  completed: "#16A34A", // green — done
  scheduled: "#0D9488", // teal — scheduled
  CustomerAccept: "#15803D", // forest — accepted
  CustomerToOp: "#DC2626", // red — sent back to OP
  CustomerToGarage: "#E11D48", // rose — sent back to garage
  OpToGarage: "#BE123C", // crimson — OP reject
  OpReject: "#BE123C",
  CustomerReject: "#B91C1C",
  expired: "#78716C", // stone — overdue (distinct from amber GarageToOp)
  default: "#64748B",
};

export const getServiceActionColor = (action, themecolors) => {
  if (SERVICE_STATUS_BASE[action] === null) {
    return (
      themecolors?.themeLightColor ||
      themecolors?.menuActiveBackground ||
      FALLBACK_THEME
    );
  }
  return SERVICE_STATUS_BASE[action] || SERVICE_STATUS_BASE.default;
};

/** Badge swatch: light tint + solid border/text/dot (enterprise chip) */
export const statusSwatch = (hex) => ({
  background: `${hex}18`,
  border: hex,
  text: hex,
  dot: hex,
});

export const getStatusColors = (status, themecolors) => {
  const hex = getServiceActionColor(status, themecolors);
  return statusSwatch(hex);
};
